import type { AuthenticatedReckonUserAttributes, SetUserProps } from './types';

export function createAuthenticatedUser(
  data: SetUserProps
): AuthenticatedReckonUserAttributes {
  const host = typeof window === 'undefined' ? 'unknow' : window.location.host;

  return { anonymous: false, ...data, host };
}
